(ns shared.core.toasts.views
  (:require [shared.core.toasts.data]
            [shared.core.components.button :as button]
            [shared.core.components.interactive :refer [interactive]]
            [shared.core.components.icon :as icon]
            [shared.core.components.theme :as theme]
            [shared.core.reactive :as re]
            [shared.core.style :as style]))

(defn toast [_]
  (let [dark?- (re/subscribe [:core/theme-dark?-])]
    (fn [{:keys [id msg kind action primary? alc?]}]
      (let [gray-border (cond
                          alc?
                          (str "1px solid " (style/alc-color "Border/divider"))

                          @dark?-
                          (str "1px solid " (style/dark-color :surface :lighter-1))

                          :else
                          (str "1px solid " (style/color :gray :shade-7)))
            base-color (cond
                         alc?
                         (condp = kind
                           :info (style/alc-color "Common/active")
                           :error (style/alc-color "Common/error"))

                         @dark?-
                         (condp = kind
                           :info (style/dark-color :primary :base)
                           :error (style/dark-color :secondary :base))

                         :else
                         (condp = kind
                           :info (if primary?
                                   "rgb(153, 51, 240)"
                                   (style/color :green :base))
                           :error (style/color :red :base)))
            remove-toast #(re/dispatch [:toasts/remove id])]
        [theme/theme
         interactive
         :div {:style (cond-> {:background-color (style/color :gray :shade-11)
                               :border-top (str "5px solid " base-color)
                               :border-right gray-border
                               :border-bottom gray-border
                               :border-left gray-border
                               :color (style/color :gray :base)
                               :font-size 14
                               :line-height 1.3
                               :cursor :pointer
                               :flex "0 0 auto"
                               :display :flex
                               :align-items :center
                               :opacity 0.8
                               :margin-top 10
                               :padding 20
                               :position :relative
                               :transition "0.2s"
                               :width 300}
                              alc? (assoc :background-color (style/alc-color "Background/secondary")
                                          :border-radius 6
                                          :color (style/alc-color "Text/primary")
                                          :opacity 1))
               :hover-style {:opacity 1}
               :theme (style/dark-style {:background-color (style/dark-color :surface :base)})
               :on-click remove-toast}
         [theme/theme
          icon/material-icon {:icon-type :close
                               :style {:font-size 18
                                       :position :absolute
                                       :top 6
                                       :right 4}
                              :theme (style/dark-style {:color (style/color :white :base)})}]
         [icon/material-icon {:icon-type (condp = kind
                                           :info :check-circle
                                           :error :error)
                              :style {:color base-color
                                      :font-size 20
                                      :flex "0 0 auto"}}]
         [theme/theme
          :span {:style {:text-overflow :ellipsis
                         :overflow :hidden
                         :flex 1
                         :margin-left 10}
                 :theme (style/dark-style {:color (style/color :white :base)})}
          msg
          (when action
            [(if (= kind :error)
               button/red-button
               button/green-button)
             {:style {:margin-top 5}
              :on-click #(do
                           (when (:on-click action)
                             ((:on-click action) %))
                           (.stopPropagation %)
                           (.preventDefault %))}
             (:text action)])]]))))

(defn active-toasts [_]
  (let [toasts- (re/subscribe [:toasts/active-])]
    (fn [{:keys [primary?]}]
      (when (some-> @toasts- (count) (pos?))
        (into [:div {:style {:display :flex
                             :flex-direction :column
                             :overflow :auto
                             :position :fixed
                             :bottom 20
                             :right 20
                             :max-height "calc(100% - 20px)"
                             :z-index (style/z :above-all)}}
               [button/white-button {:on-click #(re/dispatch [:toasts/remove-all])
                                     :style {:flex "0 0 auto"
                                             :margin-top 10}}
                "Dismiss All"]]
              (map (fn [t]
                     [toast (assoc t :primary? primary?)])
                   @toasts-))))))
